import React, { useEffect } from 'react';
import { Hero, SocialProof, Testimonials1, Problem } from './components/HeaderSections';
import { ProductTomos, Bonuses, UrgencyCounter, Pricing, Potenciador } from './components/CoreSections';
import { Testimonials2, Guarantee, FAQ, CostOfNotHaving, FinalCTA, Footer } from './components/FooterSections';
import { ExitIntentModal } from './components/ExitIntentModal';
import { SocialProofPopup } from './components/SocialProofPopup';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  useEffect(() => {
    if (typeof document !== 'undefined') {
      document.documentElement.lang = 'es-419';
      document.documentElement.setAttribute('translate', 'no');
      document.title = 'El Arsenal del Profe — Todo tu año de Educación Física, listo';
    }
  }, []);
  return <div lang="es-419" translate="no" className="min-h-screen bg-[#060f1c] font-sans text-white selection:bg-brandOrange selection:text-white notranslate" data-id="element-0" data-mp="28skzynbjv4a8">
      <MetaPixel data-id="element-1" data-mp="3ij61k21ff746" />
      <ExitIntentModal data-id="element-2" data-mp="3ijpef4c7z5bc" />
      <SocialProofPopup data-id="element-3" data-mp="3mlj82snzz920" />
      <Hero data-id="element-4" data-mp="3mkre1ma1tjdu" />
      <SocialProof data-id="element-5" data-mp="3mkhnnxl3da7m" />
      <Testimonials1 data-id="element-6" data-mp="3mjzpgvevclx2" />
      <Problem data-id="element-7" data-mp="3mj6hxs835sdv" />
      <ProductTomos data-id="element-8" data-mp="3rcj5s04xxv5k" />
      <Bonuses data-id="element-9" data-mp="3rbzomln47asl" />
      <UrgencyCounter data-id="element-10" data-mp="3rdkisa5iorpx" />
      <Pricing data-id="element-11" data-mp="3rd18nfm3z7mg" />
      <Potenciador data-id="element-12" data-mp="3relv0hy9rk98" />
      <Testimonials2 data-id="element-13" data-mp="5os92t1uy7l" />
      <Guarantee data-id="element-14" data-mp="4wvhonpuufq" />
      <FAQ data-id="element-15" data-mp="5gel8p3rovc" />
      <CostOfNotHaving data-id="element-16" data-mp="56m9egl55mh" />
      <FinalCTA data-id="element-17" data-mp="2zl3a7gleoy37" />
      <Footer data-id="element-18" data-mp="2zllf11m4wkmq" />
    </div>;
}